export const _initialState = {
  assets: []
};
